import { revokeAllGrantsOf } from "@worktools/shared";
import { useUi } from "../state/ui";
import { useBoard } from "../sync/BoardContext";
import { useMyGrants } from "../sync/hooks";


/** Explains the sharing mode while it is active and offers a global revoke. */
export function GrantBar() {
  const { doc, me } = useBoard();
  const tool = useUi((state) => state.tool);
  const setTool = useUi((state) => state.setTool);
  const grants = useMyGrants();
  const count = Object.keys(grants).length;

  if (tool !== "grant") return null;

  return (
    <div className="grantbar">
      <img className="grantbar__logo" src="/claude-logo.svg" alt="" />
      <span>
        Klicke die Blöcke an, auf die <b style={{ fontWeight: 500 }}>dein Claude</b> zugreifen darf.
        {count > 0 ? ` ${count} freigegeben.` : " Aktuell keiner freigegeben."} Andere Teilnehmer
        geben für ihren eigenen Claude frei.
      </span>
      {count > 0 && (
        <button className="ghost" onClick={() => revokeAllGrantsOf(doc, me.id)}>
          Alle aufheben
        </button>
      )}
      <button onClick={() => setTool("select")}>Fertig</button>
    </div>
  );
}
